import { ApiGatewayResponse } from '../../../for-api-gateway';
import { HasLength } from '../../fields';

export interface InputLayoutModel extends HasLength {
  clientHeaders?: string;
  fieldName?: string;
  start: number;
  source: string;
}

export interface ProgramMetadataModel {
  name: string;
  version: string;
  clonedFromProgram?: ClonedFromProgramInformation;
}

export type ProductDetailsModel = {
  programName: string;
  accountNumber: string;
  subCode: string;
  clientName: string;
  submitterEmail: string;
  submitterName: string;
  clientUserName: string;
  clientUserEmail: string;
};

export interface ProductInputModel {
  productDetails: ProductDetailsModel;
}

export interface ClonedFromProgramInformation {
  programKey?: string;
  orderName?: string;
  fileName?: string;
}

export interface AutomatedFromTemplateInformation {
  templateId?: string;
}

export interface MetadataInformation {
  clonedFromProgram?: ClonedFromProgramInformation;
  automatedFromTemplate?: AutomatedFromTemplateInformation;
}

export interface HeaderInfo {
  hasHeaders: boolean | null;
  actualHeaders: Array<string>;
  detectedHeaders: Array<Array<string>>;
}
export interface HeaderInfoData {
  fileName: string;
  headersInfo: HeaderInfo;
  errors: Record<string, string>[];
}

export type HeaderInfoApiGatewayResponse = ApiGatewayResponse<HeaderInfoData>;

export const acceptedExtensions = ['csv', 'txt', 'pgp'];
export const maxFileSize = 5368709120; // 5GB

export interface FileLayout {
  experianHeader: string | null;
  clientHeader: string;
}
export interface FileLayoutData {
  layoutId: string;
  layout: FileLayout[];
}

export type FileLayoutApiGatewayResponse = ApiGatewayResponse<FileLayoutData>;

export type SaveLayoutApiGatewayResponse = ApiGatewayResponse<{
  layoutId: string;
}>;
export const isLayoutRequired = {
  getLayout: false,
  saveLayout: false,
};
